import {getCountryByCode, loader, errorHandler, message, logout} from '@/libs/helper'
import {followUnfollow, getUserFollowersCount} from '@/libs/api/api'
import constants from '@/libs/constant/constants'
import {isEmpty, sortBy} from 'lodash'
import DetailMenu from '@/components/pages/InformationPortal/ProfilePage/DetailMenu/DetailMenu.vue'
export default {
    name: 'About',
    props: {
        updateCollectionMetaList: {
            type: Function,
            default: () => {}
        },
        isUpdateFollowers: {
            type: Boolean,
            default: false
        },
        changeUpdateFollowers: {
            type: Function,
            default: () => {}
        },
        // left menu
        module: {
            type: String,
            default: ''
        },
        details: {
            type: Object,
            default: () => {}
        },
        selectedRecord: {
            type: Object,
            default: () => {}
        },
        createDetailShortUrl: {
            type: Function,
            default: () => {}
        },
        getFavorite: {
            type: Function,
            default: () => {}
        },
        routeToDetailPage: {
            type: Function,
            default: () => {}
        },
        getIconClassName: {
            type: Function,
            default: () => {}
        },
        followCollection: {
            type: Function,
            default: () => {}
        },
        getShortUrlCollection: {
            type: Function,
            default: () => {}
        },
        routeToFollowers: {
            type: Function,
            default: () => {}
        },
        routeToCollectionAboutPage: {
            type: Function,
            default: () => {}
        },
        routeFromCollectionPage: {
            type: Function,
            default: () => {}
        },
        setFavourite: {
            type: Function,
            default: () => {}
        },
        articlesCount: {
            type: Number,
            default: 0
        },
        collectionCount: {
            type: Number,
            default: 0
        },
        followersCount: {
            type: Number,
            default: 0
        },
        collectionFollowersCount: {
            type: Number,
            default: 0
        },
        dossierCount: {
            type: Number,
            default: 0
        },
        collectionArticleCount: {
            type: Number,
            default: 0
        },
        routeToCollectionPage: {
            type: Function,
            default: () => {}
        },
        setCollectionFavorite: {
            type: Function,
            default: () => {}
        },
        isCollection: {
            type: Boolean,
            default: false
        },
        isDossier: {
            type: Boolean,
            default: false
        },
        collectionShortUrl: {
            type: String,
            default: ''
        },
        shortUrl: {
            type: String,
            default: ''
        },
        fetchMetaDetails: {
            type: Function,
            default: () => {}
        }
    },
    components: {DetailMenu},
    watch: {
        // to update the list of followers
        isUpdateFollowers (isValue) {
            if (isValue) this.getFollowers()
        }
    },
    beforeMount() {
        if (this.$route && this.$route.query && this.$route.query.type && this.$route.query.type !== undefined) {
            this.changeMenu(this.$route.query.type)
        }
    },
    data() {
        return {
            isEmpty,
            sortBy,
            activeMenu: 'author',
            searchValue: '',
            getCountryByCode,
            currentPage: 1,
            skip: 0,
            limit: 30,
            isFetching: false,
            followingList: []
        }
    },
    methods: {
        /*
         * returns the user to fetch the user's avatar.
         * */
        getURL(imageName){
            return `${process.env.VUE_APP_API_BASE_URL}/accounts/files/${imageName}?auth=${localStorage.getItem('accuraAuthToken')}`
        },
        /*
         * return the place holder image in case of error in image loading.
         * */
        onError(e) {
            let avatarURL = require('@/assets/images/author_placeholder.png');
            if (e.target.src !== avatarURL) {
                e.target.src = avatarURL;
            }
        },
        /**
         * to change the submenu
         * @param {*} menu 
         */
        changeMenu (menu) {
            // setting menu
            this.activeMenu = menu
            // clearing pagination if menu is changed
            this.clearFields()
            // if menu is followers then get the list of followers
            if (menu === constants.LIST.FOLLOWERS && this.module !== 'USER') this.getFollowers()
        },

        /**
         * to change the pages 
         * @param {*} currentPage 
         */
        changePage (currentPage) {
           // set current page
           this.currentPage = currentPage
           // setting the skip as per the current page
           this.skip = (currentPage - 1) * this.limit
        },

        /**
         * clearing fields
         */
        clearFields () {
            this.skip = 0
            this.currentPage = 1
        },
        /**
         * to follow/unfollow any auhor
         * @param {*} module 
         * @param {*} meta 
         */
        followUnfollowAction(module, meta){
            if (((this.details._id && this.details._id === meta._id ) || (this.details._id && meta.data && meta.data._id && this.details._id === meta.data._id)) && this.details.is_admin){
                message(this, constants.messageType.WARNING, ('Managed author cannot be unfollowed'))
                return
            }

            loader(this, true)

            let body = {
                id: meta.data._id
            }
            followUnfollow(body, meta.is_following ? 'unfollow' : 'follow', module.toLowerCase())
                .then(()=>{
                    loader(this, false)
                    message(this, constants.messageType.SUCCESS, `${meta.is_following ? ('Unfollowed Successfully') : ('Followed Successfully')}`);
                    this.$set(meta, 'is_following', !meta.is_following)
                    this.updateCollectionMetaList(meta, module)
                })
                .catch((error)=>{
                    loader(this, false)
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                })
        },
        /**
         * to get the followers listing
         */
        getFollowers () {
            // body for api
            this.isFetching = true
            let body = {
                entity_type: this.isDossier ? constants.LIST.DOSSIER : constants.LIST.COLLECTION,
                entity_id: this.isDossier ? this.$route.params.did : this.$route.params.cid
            }
            // api call
            getUserFollowersCount(body).then(response => {
                this.followingList = response.users || []
                this.isFetching = false
                this.changeUpdateFollowers(false)
            }).catch(error => {
                this.isFetching = false
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            })
        },
        /**
         * route to member page
         */
         routeToMemberPage (member) {
            this.$router.push({name: 'users-overview', params: {id: (member._id || member.id)}}).catch(() => {})
        }
    }
}